export type PersistedColorSchemeState = {
  darkMode: boolean;
};

export enum ColorSchemeSetting {
  Auto = `auto`,
  DarkMode = `dark-mode`,
  LightMode = `light-mode`,
}
